import { useState, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import type { TabsProps } from "antd";
import { useSelector } from 'react-redux';
import { RootState } from '@nxsys/store';
import AppTabGroupContainer from "@nxsys/components/AppTabGroupContainer";
import KIDSubcontractor from "./KIDCIS";
import KIDPAYE from "./KIDPaye";
import KIDUmbrella from "./KIDUmbrella";
import EmailSent from "./EmailSent";
import UmbrellaRateCalculator from "./UmbrellaRateCalculator";

const DocumentList = () => {
  const { messages } = useIntl();
  const { isBureau } = useSelector((state: RootState) => state.appStore);
  const [activeTab, setActiveTab] = useState("employee");

  useEffect(() => {
    if (isBureau) setActiveTab('paye');
  }, [isBureau]);

  const onTabChange = (key: string) => {
    setActiveTab(key);
  };

  const renderTabContent = (key: string) => {
    switch (key) {
      case "employee":
        return <KIDSubcontractor />;
      case "paye":
        return <KIDPAYE />;
      case "umbrella":
        return <KIDUmbrella />;
      case "email":
        return <EmailSent />;
      case "rate-calculator":
        return <UmbrellaRateCalculator />;
      default:
        return null;
    }
  };

  const items = useMemo<TabsProps["items"]>(() => {
    const allItems: TabsProps["items"] = [
      {
        label: `${messages["common.cisModel"]}`,
        key: "employee",
      },
      {
        label: `${messages["kid.paye"]}`,
        key: "paye",
      },
      {
        label: `${messages["common.umbrella"]}`,
        key: "umbrella",
      },
      {
        label: `${messages["common.emailSent"]}`,
        key: "email",
      },
      {
        label: "Rate Calculator",
        key: "rate-calculator",
      },
    ];
    if (isBureau) {
      return allItems.filter(
        (item) => item.key === 'paye' || item.key === 'email',
      );
    }
    return allItems;
  }, [isBureau, messages]);

  return (
    <>
      <AppTabGroupContainer
        items={items}
        defaultActiveTab={activeTab}
        handleTabGroupChange={onTabChange}
      />
      {renderTabContent(activeTab)}
    </>
  );
};

export default DocumentList;
